import React, { useEffect, useState } from "react";
import { listCourses } from "../../Services/courseService";
import CourseTemplate from "./CourseTemplate";

const SubCategoryCourses = () => {
    const [grouped, setGrouped] = useState({});

    useEffect(() => {
        fetchAndGroup();
    }, []);

    const fetchAndGroup = async () => {
        try {
            const response = await listCourses();
            const courses = response?.data?.data || [];

            const groupedBySub = courses.reduce((acc, course) => {
                const sub = course.subCategory || "Others";
                if (!acc[sub]) acc[sub] = [];
                acc[sub].push(course);
                return acc;
            }, {});

            setGrouped(groupedBySub);
        } catch (err) {
            console.error("Error loading courses:", err);
        }
    };

    return (
        <>
            {Object.keys(grouped).map((subCategory) =>
                grouped[subCategory].length > 0 ? (
                    <CourseTemplate
                        key={subCategory}
                        coursesData={grouped[subCategory]}
                        pageTitle={`Courses Related to ${subCategory}`}

                    />
                ) : null
            )}
        </>
    );
};

export default SubCategoryCourses;
